/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Own_Bot_Token_MalformedInputs */



/**
* | output |
* | --- |
* | "That isn't a bot token. Copy it from your app's Bot page." |
*
* @param {Settings_Own_Bot_Token_MalformedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const settings_own_bot_token_malformed = /** @type {((inputs?: Settings_Own_Bot_Token_MalformedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Own_Bot_Token_MalformedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это не токен бота. Скопируйте его на странице Bot вашего приложения.")
	return /** @type {LocalizedString} */ ("That isn't a bot token. Copy it from your app's Bot page.")
});